module.exports = {
      id: "illustrations:01B-usage",
      viewBox: "0 0 439 78",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:01B-usage",
      toString: function () {
        return this.url;
      }
    }